import { ChangeEvent } from "react";
import Select, { Option } from "../../../../base/Select/Select";
import { LABELS } from "../../../../../config/constants";

interface BathsOptionProps {
  value?: number;
  onChange: (value: number) => void;
}

const OPTIONS = [
  { label: LABELS.NO_MIN, value: 0 },
  { label: "1+", value: 1 },
  { label: "2+", value: 2 },
  { label: "3+", value: 3 },
  { label: "4+", value: 4 },
  { label: "5+", value: 5 },
  { label: "6+", value: 6 },
] satisfies Option[];

export default function BathsOption({ value, onChange }: BathsOptionProps) {
  const handleChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const newValue = Number(e.target.value);
    onChange(newValue);
  };

  return <Select label="Bathrooms" value={value} onChange={handleChange} options={OPTIONS} />;
}
